import React, {useCallback} from 'react';

//Components
import {Container} from 'react-bootstrap'
import Icon from '../../../components/Icon/Icon';
import Loader from 'react-loader-spinner'


//Hooks
import {useEffect} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";

//Actions
import {getReservations} from '../../../store/actions/reservations';

//Styles
import Styles from './Current.module.scss';
import Reservation from '../../../components/Reservation/Reservation';


const Current = () => {
    const bookings = useSelector(state => state.reservations.bookings);
    const bundles = useSelector(state => state.reservations.bundles);
    const loading = useSelector(state => state.reservations.loading);
    const noMoreBookings = useSelector(state => state.reservations.noMoreBookings);

    const dispatch = useDispatch();
    const {t} = useTranslation('common');

    const handleLoadMore = useCallback(() => {
        if (loading || noMoreBookings) {
            return;
        }
        dispatch(getReservations(bookings.length, 10, true));
    }, [loading, noMoreBookings, bookings, dispatch]);

    const handleScroll = useCallback(e => {
        const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight;
        if(!bottom) {
            return;
        }

        handleLoadMore();
    }, [handleLoadMore]);

    useEffect(() => {
        document.getElementById('scrollContainer').addEventListener('scroll', handleScroll);
        return () => {
            document.getElementById('scrollContainer').removeEventListener('scroll', handleScroll)
        }
    }, [handleScroll]);

    if (!loading && bookings.length === 0 && bundles.length === 0) {
        return (
            <div className={Styles.container}>
                <div className={Styles.iconContainer}>
                    <Icon name='calendar' size={58} color='#B3BDC8'/>
                    <p className={Styles.error}>{t('reservationsScreen.reservations.noCurrentReservations')}</p>
                </div>
            </div>
        )
    }

    return (
        <div className={Styles.container}>
            <Container className={'px-0'}>
                {bookings.map((reservation, i) => (
                    <Reservation
                        key={`product-${i}`}
                        reservation={reservation}
                        type='product'
                    />
                ))}
                {bundles.map((reservation, i) => (
                    <Reservation
                        key={`bundle-${i}`}
                        reservation={reservation}
                        type='bundle'
                    />
                ))}
            </Container>

            {loading && (
                <div className={Styles.infinityScroll}>
                    <Loader type="TailSpin" color="#000" height={25} width={25}/>
                </div>
            )}
        </div>
    )
};

export default Current